export default "__VITE_ASSET__3229afcd__"